export default __webpack_public_path__ + "static/media/icone-site-multipages.24caf7d8.svg";